app.controller("operationNoteController", [
	"$scope",
	"OperationNote",
	"OperationAPI",
	"Base64",
	"NHI",
	"$timeout",
	"Session",
	"CurrentPatient",
	"$state",
	"$filter",
	"$q",
	"$modal",
	"UserService",
	"OPERATIONPROCEDURE",
	"SurgeryAPI",
	"PreOp",
	"$window",
	"ElevenLabsAPI",
	"countryConfig",
	"ELEVEN_LABS_AI_1097",
	"toast",
	function (
		$scope,
		OperationNote,
		OperationAPI,
		Base64,
		NHI,
		$timeout,
		Session,
		CurrentPatient,
		$state,
		$filter,
		$q,
		$modal,
		UserService,
		OPERATIONPROCEDURE,
		SurgeryAPI,
		PreOp,
		$window,
		ElevenLabsAPI,
		countryConfig,
		ELEVEN_LABS_AI_1097,
		toast,
	) {
		$scope.CP = CurrentPatient;
		$scope.isHistoryCollapsed = true;
		$scope.isPlanCollapsed = true;
		$scope.displaySecondaryNHI = false;
		$scope.practiceType = Session.practice.type;
		$scope.visionAlerts = [];
		$scope.historyAlerts = [];
		$scope.planAlerts = [];
		$scope.nhi = {};
		$scope.operative_eye = "";
		$scope.Base64 = Base64;
		$scope.showCommentsOnly = false;
		$scope.displayContactTracingMessageInButtonSurround = false;
		$scope.ophthalmologists = [];
		$scope.isSubmitted = false;
		$scope.hiddenFooter = false;
		$scope.noteDetails = "";
		$scope.disableSelect = false;
		$scope.operationNoteHeader = "";
		$scope.displaySpinner = false;
		$scope.remoteDefaultSetting = null;
		$scope.PreOp = null;
		$scope.noteContent = "operation note";
		$scope.operation_note_other_procedure_settings = [];
		$scope.applyToAllUserPractices = { checked: false };
		// Set by the "submit & save values" button and acted on by submit(); see saveSetting().
		$scope.saveDefaultsRequested = false;
		// null | "pending" | "saved" | "failed" - shown in the success modal.
		$scope.defaultsSaveState = null;
		$scope.ElevenLabsAPI = ElevenLabsAPI;
		$scope.countryConfig = countryConfig;
		$scope.isAIEnabled = false;
		if (Session.practice.practiceFeatures) {
			let featureToggles = Session.practice.practiceFeatures;
			if (featureToggles.elevenLabsAiAgentFeature && ELEVEN_LABS_AI_1097) $scope.isAIEnabled = featureToggles.elevenLabsAiAgentFeature;
		}	


		$scope.US = UserService;
		$scope.US.getDoctorsByPracticeId(Session.practice.id).then(
			function (resp) {
				$scope.ophthalmologists = [];
				resp.data.forEach(function (doc) {
					$scope.ophthalmologists.push({ name: doc.firstName + " " + doc.lastName, value: doc.id });
				});
				$scope.ophthalmologists.sort(function (a, b) {
					if (a.name < b.name) {
						return -1;
					}
					if (a.name > b.name) {
						return 1;
					}
					return 0;
				});

			},
			function (err) {
				console.error("request ophthalmologists failed", err && err.status);
			}
		).then(function () {
			requestOperationNote();
		});

		function isMergeSettingNeeded(operative_eye) {
			if (operative_eye === "OD") {
				return !$scope.OperationNote.op_note_od.procedure_type;
			} else if (operative_eye === "OS") {
				return !$scope.OperationNote.op_note_os.procedure_type;
			}
			return false;
		}

		$scope.$watch(
			"operative_eye",
			function (newValue) {
				// Default settings load asynchronously (and may not exist at all), so the eye can be
				// picked before they arrive. mergeDefaultSetting copes with missing settings.
				const opNoteSettings = $scope.remoteDefaultSetting ? $scope.remoteDefaultSetting.op_note_settings : null;
				if (newValue === "OD") {
					$scope.OperationNote.op_note_od.operative_eye = "YES";
					$scope.OperationNote.op_note_os.operative_eye = "NO";
					if (isMergeSettingNeeded('OD')) {
						mergeDefaultSetting(opNoteSettings, "OD");
					}
				} else if (newValue === "OS") {
					$scope.OperationNote.op_note_os.operative_eye = "YES";
					$scope.OperationNote.op_note_od.operative_eye = "NO";
					if (isMergeSettingNeeded('OS')) {
						mergeDefaultSetting(opNoteSettings, "OS");
					}
				} else if (newValue === "BOTH") {
					$scope.OperationNote.op_note_od.operative_eye = "YES";
					$scope.OperationNote.op_note_os.operative_eye = "YES";
					if (isMergeSettingNeeded('OD')) {
						mergeDefaultSetting(opNoteSettings, "OD");
					}
					if (isMergeSettingNeeded('OS')) {
						mergeDefaultSetting(opNoteSettings, "OS");
					}
				}
				rebuildPostOpMedications();
			},
			true
		);

		$scope.$watch("OperationNote.surgeon_user_id", requestDefaultSetting, true);

		$scope.$watch(
			"OperationNote.postop_care.follow_up_type",
			(newValue) => {
				if (newValue) {
					$scope.OperationNote.postop_care.duration = newValue;
				}
			},
			true
		);

		$scope.$watch(
			"OperationNote.postop_care.follow_up_date",
			(newValue) => {
				if (newValue) {
					$scope.OperationNote.postop_care.other_date = newValue;
				}
			},
			true
		);

		$scope.saveHistory = function (isWorkup) {
			if (!$scope.history.$valid && isWorkup) {
				$scope.isPlanCollapsed = true;
				throw new Error("error in history section");
			}
			return null;
		};

		$scope.submit = function () {
			$scope.isSubmitted = true;
			const valid = checkValid();
			if (!valid) return;

			// display NHI warning if value is not present
			if ($scope.CP.patient.nhi === null && $scope.displaySecondaryNHI === false && countryConfig.nhiFeatureEnabled) {
				$scope.displaySecondaryNHI = true;
				return;
			}

			if (!$scope.showWarning) {
				$scope.showWarning = true;
				return;
			}

			// Both footer buttons share the confirm step above, so the confirming click can land on
			// either of them. A request to save the values is remembered from whichever click made it.
			if ($scope.saveDefaultsRequested && $scope.canSave()) {
				saveDefaultSettings();
			}

			$scope.displaySpinner = true;
			$scope.isSuccess = false;
			$scope.processingWorkup = $modal({
				scope: $scope,
				templateUrl: "app/src/views/templates/modal.processing-operation-note-workup.tpl.html",
				show: true,
				title: "PROCESSING...",
				keyboard: false,
				backdrop: "static",
			});
			OperationAPI.submitWorkUp(dataTransform(),$scope.opNoteOption)
				.then(function (resp) {
					downloadFile(resp.data, getFileName());
					$scope.$broadcast('trigger:automation-task');
					$scope.processingWorkup.hide();
					$scope.isSuccess = true;
					$scope.successfulWorkup = $modal({
						scope: $scope,
						templateUrl: "app/src/views/templates/modal.processing-operation-note-workup.tpl.html",
						show: true,
						title: "SUCCESS",
						keyboard: false,
						backdrop: "static",
					});

					if ($scope.opNoteOption.enableAiFollowUp && $scope.aiCallData && $scope.aiCallData.agent_id) {
						const aiData = {
							practice_id: Session.practice.id,
							patient_id: $scope.CP.patient.id,
							agent_id: $scope.aiCallData.agent_id,
							prompt_id: $scope.aiCallData.prompt_id,
							date_scheduled_utc: $scope.aiCallData.date_scheduled_utc
						};

						$scope.ElevenLabsAPI.createOutboundCall(aiData).then(function () {
							console.log("AI Follow-up call scheduled successfully");
						}).catch(function (err) {
							console.error("AI Call scheduling failed", err && err.status);
						});
					}
				})
				.catch(function (error) {
					console.error("submitWorkUp error", error && error.status);
					$scope.displaySpinner = false;
					if($scope.processingWorkup){
						$scope.processingWorkup.hide();
					}
					
					$scope.serverErrorModal = $modal({
                        scope: $scope,
                        templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
                        show: true,
                        title: "CatTrax has encountered an error",
                    });
				});
		};

		$scope.savePlan = function (isWorkup) {
			return null;
		};

		// The non-operative eye still holds whatever was on screen before the eye was switched (its
		// procedure type, merged defaults, part-filled fields). It is dropped from every request rather
		// than nulled on $scope, which broke the form (and the operative_eye watcher) if a submit failed
		// and the user carried on editing.
		function dropNonOperativeEyes(body) {
			["op_note_od", "op_note_os"].forEach(function (side) {
				if (body[side] && body[side].operative_eye === "NO") {
					body[side] = null;
				}
			});
			return body;
		}

		function dataTransform() {
			const body = dropNonOperativeEyes(angular.copy($scope.OperationNote));
			if (body.op_note_od && body.op_note_od.ccc && body.op_note_od.ccc.dilated_pupil_size) {
				if (
					typeof body.op_note_od.ccc.dilated_pupil_size === "string" &&
					body.op_note_od.ccc.dilated_pupil_size.indexOf("mm") !== -1
				) {
					//do nothing
				} else if (Number.isInteger(body.op_note_od.ccc.dilated_pupil_size)) {
					body.op_note_od.ccc.dilated_pupil_size = "_" + body.op_note_od.ccc.dilated_pupil_size + "mm";
				} else {
					body.op_note_od.ccc.dilated_pupil_size = "_" + Math.floor(body.op_note_od.ccc.dilated_pupil_size) + "_5mm";
				}
			}
			if (body.op_note_os && body.op_note_os.ccc && body.op_note_os.ccc.dilated_pupil_size) {
				if (
					typeof body.op_note_os.ccc.dilated_pupil_size === "string" &&
					body.op_note_os.ccc.dilated_pupil_size.indexOf("mm") !== -1
				) {
					//do nothing
				} else if (Number.isInteger(body.op_note_os.ccc.dilated_pupil_size)) {
					body.op_note_os.ccc.dilated_pupil_size = "_" + body.op_note_os.ccc.dilated_pupil_size + "mm";
				} else {
					body.op_note_os.ccc.dilated_pupil_size = "_" + Math.floor(body.op_note_os.ccc.dilated_pupil_size) + "_5mm";
				}
			}
			if (body.op_note_od && body.op_note_od.ccc && !body.op_note_od.ccc.technique_type) {
				body.op_note_od.ccc.technique_type = "";
			}
			if (body.op_note_os && body.op_note_os.ccc && !body.op_note_os.ccc.technique_type) {
				body.op_note_os.ccc.technique_type = "";
			}
           
			if (body.op_note_od && body.op_note_od.procedure_type === 'OTHER') {
				delete body.op_note_od.iol;
				body.op_note_od.other_procedure.description = $scope.Base64.encode(body.op_note_od.other_procedure.description);
				body.op_note_od.adjuvant_procedures = {
					planned_anterior_vitrectomy: null,
					sulcus: null,
					capsular_tension_ring: null,
					intravitreal_injection: null,
					migs: null,
					other: null
				};
			}else if(body.op_note_od && body.op_note_od.procedure_type !== 'OTHER'){
				delete body.op_note_od.other_procedure;
			}

			if (body.op_note_os && body.op_note_os.procedure_type === 'OTHER') {
				delete body.op_note_os.iol;
				body.op_note_os.other_procedure.description = $scope.Base64.encode(body.op_note_os.other_procedure.description);
				body.op_note_os.adjuvant_procedures = {
					planned_anterior_vitrectomy: null,
					sulcus: null,
					capsular_tension_ring: null,
					intravitreal_injection: null,
					migs: null,
					other: null
				};
			} else if(body.op_note_os && body.op_note_os.procedure_type !== 'OTHER') {
				delete body.op_note_os.other_procedure;
			}


			return body;
		}

		function cutRequestForSetting() {
			const body = dropNonOperativeEyes(angular.copy($scope.OperationNote));

			// Pupil size is a finding about this patient, not a default.
			if (body.op_note_od && body.op_note_od.ccc) {
				body.op_note_od.ccc.dilated_pupil_size = null;
			}

			if (body.op_note_os && body.op_note_os.ccc) {
				body.op_note_os.ccc.dilated_pupil_size = null;
			}
			
			return adaptPostmedication(body);
		}

		function adaptPostmedication(data) {
			// Check if there are any medications to process
			if (data.postop_medications && data.postop_medications.length > 0) {

				// Filter medications for the Right Eye (OD)
				if (data.op_note_od?.operative_eye === "YES") {
					const odRelevantMeds = data.postop_medications.filter(med =>
						med.route === 'OD' || med.route === 'BOTH' || med.route === 'ORAL'
					);
					data.op_note_od.postop_medications = angular.copy(odRelevantMeds);
				}

				// Filter medications for the Left Eye (OS)
				if (data.op_note_os?.operative_eye === "YES") {
					const osRelevantMeds = data.postop_medications.filter(med =>
						med.route === 'OS' || med.route === 'BOTH' || med.route === 'ORAL'
					);
					data.op_note_os.postop_medications = angular.copy(osRelevantMeds);
				}

				// Clean up the root-level array before sending to the server
				delete data.postop_medications;
			}
			return data;
		}

		$scope.downloadPDF = function (note) {
			OperationAPI.downloadPDF(note.patient_id, note.operation_note_id).then(function (resp) {
				downloadFile(resp.data, getFileName());
			});
		};

		$scope.submitWorkUp = function () {
			// display NHI warning if value is not present
			if ($scope.CP.patient.nhi === null && $scope.displaySecondaryNHI === false && countryConfig.nhiFeatureEnabled) {
				$scope.displaySecondaryNHI = true;
				return;
			}
		};

		$scope.closeAlert = function (index, arr) {
			arr.splice(index, 1);
		};

		$scope.returnToSearch = function () {
			$scope.successfulWorkup.hide();
			$scope.CP.clearPatientResult();
			$state.go("patient-dashboard");
		};

		$scope.sugicalHistory = function () {
			$scope.successfulWorkup && $scope.successfulWorkup.hide();
			$scope.remoteDefaultSetting = null;
			// requestOperationNote();
			$window.history.back();
		};

		$scope.returnToHome = function () {
			$scope.successfulWorkup && $scope.successfulWorkup.hide();
			$scope.CP.clearPatientResult();
			$state.go("welcome");
		}

		$scope.showAppendButton = function (note) {
			$scope.showCommentsOnly = true;
			$scope.hiddenFooter = false;
			$scope.operative_eye = note.eye === "OD/OS" ? "BOTH" : note.eye;
			$scope.disableSelect = note.eye === "OD/OS" ? false : true;
			$scope.OperationNoteList = [];
			$scope.OperationNote = {
				operation_note_id: note.operation_note_id,
				patient_id: note.patient_id,
				op_note_od: { operative_eye: "NO" },
				op_note_os: { operative_eye: "NO" },
			};
			// $scope.successfulWorkup && $scope.successfulWorkup.hide();
		};

		$scope.saveSetting = function () {
			// Remembered rather than acted on here: submit() owns the validation and the confirm step,
			// and saves the defaults once the submission is confirmed, whichever button confirms it.
			$scope.saveDefaultsRequested = true;
			$scope.submit();
		};

		// Runs alongside the op note submission. The outcome is shown in the success modal and, when
		// the save fails, as a toast as well, so a surgeon no longer finds out on their next op note.
		function saveDefaultSettings() {
			$scope.defaultsSaveState = "pending";
			OperationAPI.saveDefaultSetting(cutRequestForSetting(), $scope.applyToAllUserPractices.checked)
				.then(function (resp) {
					OperationNote.setDefaultSetting(resp.data);
					$scope.defaultsSaveState = "saved";
				})
				.catch(function (error) {
					console.error("Saving default settings failed", error && error.status);
					$scope.defaultsSaveState = "failed";
					toast.create({
						timeout: 8000,
						message: "Your op note defaults could not be saved. Your previous defaults are unchanged.",
						className: "alert-danger",
						dismissible: true,
					});
				});
		}

		$scope.addComment = function () {
			if (!$scope.vision.$valid) return;
			const body = {
				op_note_od_comment: $scope.OperationNote.op_note_od.comment,
				op_note_os_comment: $scope.OperationNote.op_note_os.comment,
			};
			OperationAPI.addNewComment($scope.OperationNote.patient_id, $scope.OperationNote.operation_note_id, body)
				.then(function (resp) {
					requestOperationNote();
					$scope.showCommentsOnly = false;
				})
				.catch(function (error) {
					console.error("append comment failed", error && error.status);
				});
		};
		$scope.canSave = function () {
			//NOTE: remove "&& phaco&IOL", so taht all settings can be saved
			return $scope.OperationNote && $scope.OperationNote.surgeon_user_id === parseInt(Session.userId) && phacoAndIOL();
		};

		function requestWorkUp() {
			SurgeryAPI.getWorkUpDetails($scope.CP.patient.id).then(function () {
				$scope.PreOp = PreOp.data;
				// mergePreOp();
			});
		}

		function mergePreOp(eyes) {
			// The workup is fetched asynchronously and may not have arrived (or may not exist).
			if (!$scope.PreOp || !$scope.OperationNote) {
				return;
			}
			const preOpVision = $scope.PreOp.vision_section && $scope.PreOp.vision_section.vision;

			/**For brand new patient without workup, don't prepopulate IOL */
			if (!preOpVision || !preOpVision.od) {
				if (eyes === "OD" && $scope.OperationNote.op_note_od.iol) {
					$scope.OperationNote.op_note_od.iol = {};
					return;
				}
				
			}

			/**For brand new patient without workup, don't prepopulate IOL */
			if (!preOpVision || !preOpVision.os) {
				if (eyes === "OS" && $scope.OperationNote.op_note_os.iol) {
					$scope.OperationNote.op_note_os.iol = {};
					return;
				}
			}

			if ($scope.PreOp.surgical_plan_section && $scope.PreOp.surgical_plan_section.surgical_plan_intraocular) {
				const od = $scope.PreOp.surgical_plan_section.surgical_plan_intraocular.od;
				const os = $scope.PreOp.surgical_plan_section.surgical_plan_intraocular.os;

				if (od && eyes === "OD") {
					if (!$scope.OperationNote.op_note_od.iol) {
						$scope.OperationNote.op_note_od.iol = {};
					}

					$scope.OperationNote.op_note_od.iol.lens_type = od.lens_type;
					$scope.OperationNote.op_note_od.iol.lens_model = od.lens_model;
					$scope.OperationNote.op_note_od.iol.lens_power_spherical = od.lens_power_spherical;
					$scope.OperationNote.op_note_od.iol.lens_power_cylinder = od.lens_power_cylinder;

					$scope.OperationNote.op_note_od.iol.lens_axis = null; // od.intended_axis;
					// $scope.OperationNote.op_note_od.iol.target_refraction_cylinder = od.target_refraction_cylinder;
					// $scope.OperationNote.op_note_od.iol.target_refraction_axis = od.target_refraction_axis;
					// $scope.OperationNote.op_note_od.iol.target_refraction_sphere = od.target_refraction_sphere;

					if (["NON_TORIC_ADDON", "TORIC_ADDON"].includes($scope.OperationNote.op_note_od.iol.lens_type)) {
						$scope.OperationNote.op_note_od.iol.lens_placement = "Sulcus";
					}
				}

				if (os && eyes === "OS") {
					if (!$scope.OperationNote.op_note_os.iol) {
						$scope.OperationNote.op_note_os.iol = {};
					}
					$scope.OperationNote.op_note_os.iol.lens_type = os.lens_type;
					$scope.OperationNote.op_note_os.iol.lens_model = os.lens_model;
					$scope.OperationNote.op_note_os.iol.lens_power_spherical = os.lens_power_spherical;
					$scope.OperationNote.op_note_os.iol.lens_power_cylinder = os.lens_power_cylinder;

					$scope.OperationNote.op_note_os.iol.lens_axis = null; // os.intended_axis;
					// $scope.OperationNote.op_note_os.iol.target_refraction_cylinder = os.target_refraction_cylinder;
					// $scope.OperationNote.op_note_os.iol.target_refraction_axis = os.target_refraction_axis;
					// $scope.OperationNote.op_note_os.iol.target_refraction_sphere = os.target_refraction_sphere;

					if (["NON_TORIC_ADDON", "TORIC_ADDON"].includes($scope.OperationNote.op_note_os.iol.lens_type)) {
						$scope.OperationNote.op_note_os.iol.lens_placement = "Sulcus";
					}
					// $scope.OperationNote.op_note_od.iol.lens_serial_number = os.lens_serial_number;
				}
			}
			/**
			 * anaesthetic will be overrided by preop surgical_plan_section
			 */
			if ($scope.PreOp.surgical_plan_section && $scope.PreOp.surgical_plan_section.surgical_plan_anaesthetic) {
				$scope.OperationNote.op_note_od.anaesthetic = $scope.PreOp.surgical_plan_section.surgical_plan_anaesthetic.anaesthetic;
				$scope.OperationNote.op_note_os.anaesthetic = $scope.PreOp.surgical_plan_section.surgical_plan_anaesthetic.anaesthetic;
			}

			if ($scope.PreOp.surgical_plan_section && $scope.PreOp.surgical_plan_section.surgical_plan_adjuvant) {
				const od = $scope.PreOp.surgical_plan_section.surgical_plan_adjuvant.od;
				const os = $scope.PreOp.surgical_plan_section.surgical_plan_adjuvant.os;

				if (od && eyes === "OD") {
					if (!$scope.OperationNote.op_note_od.adjuvant_procedures) {
						$scope.OperationNote.op_note_od.adjuvant_procedures = {};
					}
					if (od.adjuvant_procedures === "NO") {
						// $scope.OperationNote.op_note_od.adjuvant_procedures.adjuvant_procedures = od.adjuvant_procedures;
					} else {
						// $scope.OperationNote.op_note_od.adjuvant_procedures.planned_anterior_vitrectomy =
						// 	od.adjuvant_procedures && od.adjuvant_procedures === "NO" ? null : od.planned_anterior_vitrectomy;
						// $scope.OperationNote.op_note_od.adjuvant_procedures.sulcus =
						// 	od.adjuvant_procedures && od.adjuvant_procedures === "NO" ? null : od.sulcus_sutured_lens;
						// $scope.OperationNote.op_note_od.adjuvant_procedures.capsular_tension_ring =
						// 	od.adjuvant_procedures && od.adjuvant_procedures === "NO" ? null : od.capsular_tension_ring;
						// $scope.OperationNote.op_note_od.adjuvant_procedures.intravitreal_injection =
						// 	od.adjuvant_procedures && od.adjuvant_procedures === "NO" ? null : od.intravitreal_injection;
						// $scope.OperationNote.op_note_od.adjuvant_procedures.migs =
						// 	od.adjuvant_procedures && od.adjuvant_procedures === "NO" ? null : od.migs_stent;
						$scope.OperationNote.op_note_od.adjuvant_procedures.other = od.other ? [od.other] : null;
					}
				}

				if (os && eyes === "OS") {
					if (!$scope.OperationNote.op_note_os.adjuvant_procedures) {
						$scope.OperationNote.op_note_os.adjuvant_procedures = {};
					}
					if (os.adjuvant_procedures === "NO") {
						// $scope.OperationNote.op_note_os.adjuvant_procedures.adjuvant_procedures = os.adjuvant_procedures;
					} else {
						// $scope.OperationNote.op_note_os.adjuvant_procedures.planned_anterior_vitrectomy = (os.adjuvant_procedures && os.adjuvant_procedures === 'NO') ? null : os.planned_anterior_vitrectomy;
						// $scope.OperationNote.op_note_os.adjuvant_procedures.sulcus = (os.adjuvant_procedures && os.adjuvant_procedures === 'NO') ? null : os.sulcus_sutured_lens;
						// $scope.OperationNote.op_note_os.adjuvant_procedures.capsular_tension_ring = (os.adjuvant_procedures && os.adjuvant_procedures === 'NO') ? null : os.capsular_tension_ring;
						// $scope.OperationNote.op_note_os.adjuvant_procedures.intravitreal_injection = (os.adjuvant_procedures && os.adjuvant_procedures === 'NO') ? null : os.intravitreal_injection;
						// $scope.OperationNote.op_note_os.adjuvant_procedures.migs = (os.adjuvant_procedures && os.adjuvant_procedures === 'NO') ? null : os.migs_stent;
						$scope.OperationNote.op_note_os.adjuvant_procedures.other = os.other ? [os.other] : null;
					}
				}
			}
		}

		function createNewForm() {
			let patient_id = $scope.CP.patient.id;
			if ($scope.OperationNoteList.length > 0) {
				patient_id = $scope.OperationNoteList[0].patient_id;
			}
			const completed_by_user_id = Session.userId;
			const practice_id = Session.practice.id;
			$scope.OperationNoteList = [];
			$scope.operative_eye = "";
			$scope.disableSelect = false;
			$scope.hiddenFooter = false;
			$scope.OperationNote = {
				operation_note_id: null,
				patient_id: patient_id,
				completed_by_user_id: completed_by_user_id,
				surgeon_user_id: null,
				assistant_user_id: null,
				practice_id: practice_id,
				status: null,
				date_created: null,
				date_updated: null,
				op_note_od: {},
				op_note_os: {},
				postop_medications: [],
				postop_care: null,
			};
			const currentSurgeon = $scope.ophthalmologists.find((t) => t.value == Session.userId);
			$scope.OperationNote.surgeon_user_id = currentSurgeon ? currentSurgeon.value : null;
			$scope.operationNoteHeader = "OPERATION NOTE";
			if (!$scope.PreOp) {
				requestWorkUp();
			} else {
				// mergePreOp();
			}

			// $scope.successfulWorkup.hide();
		};

		function requestOperationNote() {
			$scope.showWarning = false;
			$scope.saveDefaultsRequested = false;
			$scope.defaultsSaveState = null;
			$scope.displaySecondaryNHI = false;

			// OperationAPI.getOperationNotes($scope.CP.patient.id).then(function () {
			if (OperationNote.noteList.length === 0) {
				$scope.OperationNote = OperationNote.data;
				$scope.OperationNoteList = [];
				$scope.operationNoteHeader = "OPERATION NOTE";
				createNewForm();
				requestWorkUp();
			} else {
				$scope.OperationNoteList = [];
				createNewForm();
				/**  DONOT SHOW HISTORY
				$scope.OperationNoteList = OperationNote.noteList;
				$scope.operationNoteHeader = "SURGICAL HISTORY"; */
				return;
			}
			let flag = $scope.operative_eye;
			if ($scope.OperationNote.op_note_od !== null && $scope.OperationNote.op_note_od.operative_eye === "YES") {
				flag = "OD";
			}

			if ($scope.OperationNote.op_note_os !== null && $scope.OperationNote.op_note_os.operative_eye === "YES") {
				flag = flag + "OS";
			}
			$scope.operative_eye = flag === "ODOS" ? "BOTH" : flag;
			composeNoteDetails();
			// const currentSurgeon = $scope.ophthalmologists.find((t) => t.value === Session.userId);
			// $scope.OperationNote.surgeon_user_id = currentSurgeon ? currentSurgeon.value : null;
			// });
		}

		function downloadFile(data, filename, mime, bom) {
			// https://github.com/kennethjiang/js-file-download/blob/master/file-download.js
			var blobData = typeof bom !== "undefined" ? [bom, data] : [data];
			var blob = new Blob(blobData, { type: "application/pdf" });
			if (typeof window.navigator.msSaveBlob !== "undefined") {
				// IE workaround for "HTML7007: One or more blob URLs were
				// revoked by closing the blob for which they were created.
				// These URLs will no longer resolve as the data backing
				// the URL has been freed."
				window.navigator.msSaveBlob(blob, filename);
			} else {
				var blobURL = window.URL.createObjectURL(blob);
				var tempLink = document.createElement("a");
				tempLink.style.display = "none";
				tempLink.href = blobURL;
				tempLink.setAttribute("download", filename);

				// Safari thinks _blank anchor are pop ups. We only want to set _blank
				// target if the browser does not support the HTML5 download attribute.
				// This allows you to download files in desktop safari if pop up blocking
				// is enabled.
				if (typeof tempLink.download === "undefined") {
					tempLink.setAttribute("target", "_blank");
				}

				document.body.appendChild(tempLink);
				tempLink.click();
				document.body.removeChild(tempLink);
				window.URL.revokeObjectURL(blobURL);
				$scope.displaySpinner = false;
			}
		}

		function getFileName() {
			var theTime = $filter("date")(new Date(), "yyyy-MM-dd@hmma");
			return (
				"CatTrax_operation_note_" +
				theTime +
				"_" +
				$scope.CP.patient.firstName +
				"_" +
				$scope.CP.patient.lastName +
				"_" +
				$scope.CP.patient.dateOfBirth +
				".pdf"
			);
		}

		function phacoAndIOL() {
			return (
				($scope.OperationNote.op_note_od && $scope.OperationNote.op_note_od.operative_eye === "YES") ||
				($scope.OperationNote.op_note_os && $scope.OperationNote.op_note_os.operative_eye === "YES")
			);
		}

		let defaultSettingRequestId = 0;
		function requestDefaultSetting() {
			if (
				$scope.OperationNote &&
				$scope.OperationNote.surgeon_user_id &&
				$scope.OperationNote.operation_note_id == null
				//&&
				// phacoAndIOL() &&
				// $scope.remoteDefaultSetting == null
			) {
				const requestId = ++defaultSettingRequestId;
				OperationNote.setDefaultSetting(null);
				// Don't keep applying the previous surgeon's defaults while (or if) this request fails.
				$scope.remoteDefaultSetting = null;
				OperationAPI.getDefaultSetting($scope.OperationNote.surgeon_user_id, $scope.CP.patient.id).then(function () {
					if (requestId !== defaultSettingRequestId) {
						// A newer surgeon was picked while this was in flight; the service has just
						// overwritten the shared setting with this stale response, so put back the current one.
						OperationNote.setDefaultSetting(angular.copy($scope.remoteDefaultSetting));
						return;
					}
					$scope.remoteDefaultSetting = angular.copy(OperationNote.setting);

					transformFavoriteProcedureList($scope.remoteDefaultSetting);

					if ($scope.remoteDefaultSetting && $scope.remoteDefaultSetting.op_note_settings) {
						$scope.isSubmitted = false;
						if ($scope.remoteDefaultSetting.op_note_settings.operation_note_other_procedure_settings) {
							$scope.operation_note_other_procedure_settings = angular.copy(
								$scope.remoteDefaultSetting.op_note_settings.operation_note_other_procedure_settings
							);
						}else{
							$scope.operation_note_other_procedure_settings = [];
						}
						// mergeDefaultSetting($scope.remoteDefaultSetting.op_note_settings, 'OU');
					}else{
						// should reset operation_note_other_procedure_settings
						$scope.operation_note_other_procedure_settings = [];
					}

					// Defaults that arrive after an eye was picked (a surgeon change, or a slow first load) are
					// applied the way the eye watcher would have: only into an eye with no procedure yet, and
					// the post-op medications are rebuilt from this surgeon's defaults rather than left as the
					// previous surgeon's, or as empty.
					if ($scope.operative_eye) {
						const opNoteSettings = $scope.remoteDefaultSetting ? $scope.remoteDefaultSetting.op_note_settings : null;
						if (($scope.operative_eye === "OD" || $scope.operative_eye === "BOTH") && isMergeSettingNeeded('OD')) {
							mergeDefaultSetting(opNoteSettings, "OD");
						}
						if (($scope.operative_eye === "OS" || $scope.operative_eye === "BOTH") && isMergeSettingNeeded('OS')) {
							mergeDefaultSetting(opNoteSettings, "OS");
						}
						rebuildPostOpMedications();
					}
				});

				if (!$scope.OperationNote.postop_care) $scope.OperationNote.postop_care = {};
				// The surgeon may not be in this practice's list; surgeonHeader fills the clinician in too.
				const surgeon = $scope.ophthalmologists.find((t) => t.value === $scope.OperationNote.surgeon_user_id);
				if (surgeon) {
					$scope.OperationNote.postop_care.clinician = surgeon.name;
				}
			}
		}

		function composeNoteDetails() {
			let str = "";
			if ($scope.OperationNote.op_note_od.procedure_type) {
				str =
					"right eye " +
					OPERATIONPROCEDURE.find((t) => t.id === $scope.OperationNote.op_note_od.procedure_type).name +
					" procedure";
			}
			if ($scope.OperationNote.op_note_os.procedure_type) {
				str =
					str +
					" left eye " +
					OPERATIONPROCEDURE.find((t) => t.id === $scope.OperationNote.op_note_os.procedure_type).name +
					" procedure";
			}
			$scope.noteDetails = str;
		}

		function checkValid() {
			let valid = $scope.vision.$valid;
			if (!valid) {
				const copyError = [];
				if ($scope.vision.$error.required) {
					$scope.vision.$error.required.forEach((t) => {
						if (-1 === t.$name.indexOf("eye_sub_form")) {
							copyError.push(t);
						}
					});
				}
				if (copyError.length === 0) {
					valid = true;
				}
			}

			// The incision rule below blocks submit with no field of its own to go red, so it is named in the
			// footer the same way a missing payer is. Mirrors the branches that follow.
			const lacksIncisions = function (side) {
				const section = $scope.OperationNote[side];
				return !!section && section.procedure_type !== 'OTHER'
					&& !(section.incisions && section.incisions.length > 0);
			};
			$scope.incisionMissing =
				($scope.operative_eye === "OD" && lacksIncisions("op_note_od")) ||
				($scope.operative_eye === "OS" && lacksIncisions("op_note_os")) ||
				($scope.operative_eye === "BOTH" && (lacksIncisions("op_note_od") || lacksIncisions("op_note_os")));

			if ($scope.operative_eye === "OD" && $scope.OperationNote.op_note_od.procedure_type !== 'OTHER') {
				valid =
					valid &&
					$scope.OperationNote.op_note_od.incisions &&
					$scope.OperationNote.op_note_od.incisions.length > 0;
			} else if ($scope.operative_eye === "OS" && $scope.OperationNote.op_note_os.procedure_type !== 'OTHER') {
				valid =
					valid &&
					$scope.OperationNote.op_note_os.incisions &&
					$scope.OperationNote.op_note_os.incisions.length > 0;
			} else if($scope.operative_eye === "BOTH") {
				if ($scope.OperationNote.op_note_od.procedure_type !== 'OTHER') {
					valid =
						valid &&
						$scope.OperationNote.op_note_od.incisions &&
						$scope.OperationNote.op_note_od.incisions.length > 0
				}
				if ($scope.OperationNote.op_note_os.procedure_type !== 'OTHER') {
					valid =
						valid &&
						$scope.OperationNote.op_note_os.incisions &&
						$scope.OperationNote.op_note_os.incisions.length > 0;
				}
				
			}

			// Ensure a concept has actually been chosen for OTHER procedures.
			if ($scope.operative_eye === "OD" || $scope.operative_eye === "BOTH") {
				if ($scope.OperationNote.op_note_od && $scope.OperationNote.op_note_od.procedure_type === 'OTHER') {
					if (!$scope.OperationNote.op_note_od.other_procedure || !$scope.OperationNote.op_note_od.other_procedure.primary_procedure) {
						valid = false;
					}
				}
			}

			if ($scope.operative_eye === "OS" || $scope.operative_eye === "BOTH") {
				if ($scope.OperationNote.op_note_os && $scope.OperationNote.op_note_os.procedure_type === 'OTHER') {
					if (!$scope.OperationNote.op_note_os.other_procedure || !$scope.OperationNote.op_note_os.other_procedure.primary_procedure) {
						valid = false;
					}
				}
			}

			// Every eye being operated on has to say who pays for it. The op note snapshots the
			// payer, and a note submitted without one cannot be billed without going back to the
			// surgeon. Checked against the sections rather than the form so it holds however the
			// answer got there.
			//
			// This only ever blocks when the user genuinely has a choice: the Payer control fills
			// itself in when the answer is implicit - a public hospital, a patient with a single
			// insurer, or one recorded as self-paying - and hides itself in those cases.
			//
			// The Payer control only renders where countryConfig.nhiFeatureEnabled, so only require a
			// payer there - elsewhere nothing could ever set it and submit would be blocked silently.
			$scope.payerMissing = countryConfig.nhiFeatureEnabled && ["op_note_od", "op_note_os"].some(function (side) {
				var section = $scope.OperationNote[side];
				return section && section.operative_eye === "YES" && !section.payer;
			});
			if ($scope.payerMissing) {
				valid = false;
			}

			//valid = valid && $scope.OperationNote.postop_medications.length > 0;
			return valid;
		}

		$scope.hideSecondaryNhiComponent = function () {
			$scope.displaySecondaryNHI = false;
		};

		$scope.procedureChangedOD = function () {
			if (!$scope.OperationNote) return;
			const copy = angular.copy($scope.OperationNote);
			const newProcedureType = copy.op_note_od.procedure_type;

			// Start by resetting all relevant fields
			copy.op_note_od.ovd = [];
			copy.op_note_od.ccc = {};
			copy.op_note_od.phaco = {};
			copy.op_note_od.iol = {};
			copy.op_note_od.anaesthetic = null;
			copy.op_note_od.incisions = null;
			copy.op_note_od.intraoperative_medications = [];

			// Now, conditionally delete entire sections if the new procedure doesn't use them
			if (newProcedureType && !['ABORTED_PROCEDURE', 'PHACO_IOL', 'PHACO_NO_IOL', 'IOL_IMPLANTATION'].includes(newProcedureType)) {
				delete copy.op_note_od.ccc;
			}
			if (newProcedureType && !['ABORTED_PROCEDURE', 'PHACO_IOL', 'PHACO_NO_IOL'].includes(newProcedureType)) {
				delete copy.op_note_od.phaco;
			}

			$scope.OperationNote = copy;

			// Finally, load the default settings for the newly selected procedure
			if ($scope.remoteDefaultSetting && $scope.remoteDefaultSetting.op_note_settings) {
				mergeDefaultSetting($scope.remoteDefaultSetting.op_note_settings, 'OD');
			}

			rebuildPostOpMedications();
			mergePreOp('OD');
		}

		$scope.procedureChangedOS = function () {
			if (!$scope.OperationNote) return;
			const copy = angular.copy($scope.OperationNote);
			const newProcedureType = copy.op_note_os.procedure_type;

			// Start by resetting all relevant fields
			copy.op_note_os.ovd = [];
			copy.op_note_os.ccc = {};
			copy.op_note_os.phaco = {};
			copy.op_note_os.iol = {};
			copy.op_note_os.anaesthetic = null;
			copy.op_note_os.incisions = null;
			copy.op_note_os.intraoperative_medications = [];

			// Now, conditionally delete entire sections if the new procedure doesn't use them
			if (newProcedureType && !['ABORTED_PROCEDURE', 'PHACO_IOL', 'PHACO_NO_IOL', 'IOL_IMPLANTATION'].includes(newProcedureType)) {
				delete copy.op_note_os.ccc;
			}
			if (newProcedureType && !['ABORTED_PROCEDURE', 'PHACO_IOL', 'PHACO_NO_IOL'].includes(newProcedureType)) {
				delete copy.op_note_os.phaco;
			}

			$scope.OperationNote = copy;

			// Finally, load the default settings for the newly selected procedure
			if ($scope.remoteDefaultSetting && $scope.remoteDefaultSetting.op_note_settings) {
				mergeDefaultSetting($scope.remoteDefaultSetting.op_note_settings, 'OS');
			}

			rebuildPostOpMedications();
			mergePreOp('OS');
		}
        //medications,care, eyes
		$scope.setDefaultMedications = function (result) {
			const {medications,care, eyes} = result;
			const copy = angular.copy($scope.OperationNote);
			if(!medications){
				return;
			}
			medications.forEach((t) => {
				if (t.route !== "ORAL") {
					t.route = eyes;
				}
			});
			copy.postop_medications = _mergePostOpMedications(copy.postop_medications, medications, eyes);
			

			// Merge postop_care

			if (care) {
				if (!copy.postop_care) copy.postop_care = {};
				copy.postop_care.duration = care.duration || copy.postop_care.duration;
				copy.postop_care.follow_up_type = copy.postop_care.duration;
				copy.postop_care.other_date = care.other_date || copy.postop_care.other_date;
				copy.postop_care.follow_up_date = copy.postop_care.other_date;
				copy.postop_care.clinician = care.clinician || copy.postop_care.clinician;
			}
			$scope.OperationNote = copy;
		}

		function _mergePostOpMedications(existingValue, newValue, eyes) {
			//Delete medications from existingValue (based on eyes)
			const temp = [];
			existingValue.forEach(t => {
				if (t.route === eyes && t.route !== 'ORAL') {
					// do nothing
				} else if (t.route === 'BOTH') {
					temp.push({ ...t, route: eyes === 'OD' ? 'OS' : 'OD' });
				} else {
					temp.push(t);
				}
			});

			const copyExistingValue = angular.copy(temp);			
			const appendArray = [];
			newValue.forEach(t => {
				const target = copyExistingValue.find(m => m.medication === t.medication &&
					m.dose === t.dose &&
					m.frequency === t.frequency &&
					m.duration === t.duration);
				if (target && target.route !== "ORAL") {
					if (target.route !== t.route) {
						target.route = 'BOTH';
					}
				} else {
					appendArray.push(t);
				}
			});
			appendArray.forEach(t => copyExistingValue.push(t));
			return copyExistingValue;
		}

		function mergeDefaultSetting(op_note_settings, eyes) {
			mergePreOp(eyes);
			const copy = angular.copy($scope.OperationNote);

			if(!op_note_settings){
				return;
			}

			// --- LOGIC FOR OD (Right Eye) ---
			if (eyes === 'OD' || eyes === 'BOTH') {
				const settingsList = op_note_settings.op_note_od_settings_list;

				if (settingsList && settingsList.length > 0) {
					let settingsToApply = null;
					const currentProcedureType = copy.op_note_od.procedure_type;

					if (currentProcedureType) {
						settingsToApply = settingsList.find(s => s.procedure_type === currentProcedureType);
					} else {
						// Prioritize 'PHACO_IOL' as the default procedure if it exists.
						settingsToApply = settingsList.find(s => s.procedure_type === 'PHACO_IOL');
					}

					if (settingsToApply) {
						// Copied so that edits on the form (adding an incision, say) don't change the cached defaults.
						settingsToApply = angular.copy(settingsToApply);
						copy.op_note_od.procedure_type = settingsToApply.procedure_type;
						copy.op_note_od.anaesthetic = settingsToApply.anaesthetic;
						copy.op_note_od.incisions = settingsToApply.incisions;
						copy.op_note_od.ovd = settingsToApply.ovd;
						if (settingsToApply.ccc) {
							if (!copy.op_note_od.ccc) copy.op_note_od.ccc = {};
							copy.op_note_od.ccc.dilated_pupil_size = settingsToApply.ccc.dilated_pupil_size;
							copy.op_note_od.ccc.pupil_expander = settingsToApply.ccc.pupil_expander;
							copy.op_note_od.ccc.technique_type = settingsToApply.ccc.technique_type;
							copy.op_note_od.ccc.hydrodissection_type = settingsToApply.ccc.hydrodissection_type;
						}
						if (settingsToApply.phaco) {
							if (!copy.op_note_od.phaco) copy.op_note_od.phaco = {};
							copy.op_note_od.phaco.machine = settingsToApply.phaco.machine;
							copy.op_note_od.phaco.technique = settingsToApply.phaco.technique;
							copy.op_note_od.phaco.irrigation = settingsToApply.phaco.irrigation;
						}
						if (settingsToApply.iol) {
							if (!copy.op_note_od.iol) copy.op_note_od.iol = {};
							if (!copy.op_note_od.iol.lens_type) {
								copy.op_note_od.iol.lens_type = settingsToApply.iol.lens_type;
								copy.op_note_od.iol.lens_model = settingsToApply.iol.lens_model;
								copy.op_note_od.iol.lens_power_spherical = settingsToApply.iol.lens_power_spherical;
								copy.op_note_od.iol.lens_power_cylinder = settingsToApply.iol.lens_power_cylinder;
								copy.op_note_od.iol.lens_axis = settingsToApply.iol.lens_axis;
							}
							copy.op_note_od.iol.lens_placement = settingsToApply.iol.lens_placement;
						}
						copy.op_note_od.intraoperative_medications = settingsToApply.intraoperative_medications;
						copy.op_note_od.instructions_for_patient = settingsToApply.instructions_for_patient;
						//
						if (settingsToApply.postop_care) {
							if(!copy.postop_care) {
								copy.postop_care = {};
							}
							copy.postop_care.duration = settingsToApply.postop_care.duration || copy.postop_care.duration;
							copy.postop_care.follow_up_type = copy.postop_care.duration;
							copy.postop_care.other_date = settingsToApply.postop_care.other_date || copy.postop_care.other_date;
							copy.postop_care.follow_up_date = copy.postop_care.other_date;
							copy.postop_care.clinician = settingsToApply.postop_care.clinician || copy.postop_care.clinician;
						}
					}
				}
			}

			// --- LOGIC FOR OS (Left Eye) ---
			if (eyes === 'OS' || eyes === 'BOTH') {
				const settingsList = op_note_settings.op_note_os_settings_list;
				if (settingsList && settingsList.length > 0) {
					let settingsToApply = null;
					const currentProcedureType = copy.op_note_os.procedure_type;
					if (currentProcedureType) {
						settingsToApply = settingsList.find(s => s.procedure_type === currentProcedureType);
					} else {
						// Prioritize 'PHACO_IOL' as the default procedure if it exists.
						settingsToApply = settingsList.find(s => s.procedure_type === 'PHACO_IOL');
					}
					if (settingsToApply) {
						// Copied so that edits on the form (adding an incision, say) don't change the cached defaults.
						settingsToApply = angular.copy(settingsToApply);
						copy.op_note_os.procedure_type = settingsToApply.procedure_type;
						copy.op_note_os.anaesthetic = settingsToApply.anaesthetic;
						copy.op_note_os.incisions = settingsToApply.incisions;
						copy.op_note_os.ovd = settingsToApply.ovd;
						if (settingsToApply.ccc) {
							if (!copy.op_note_os.ccc) copy.op_note_os.ccc = {};
							copy.op_note_os.ccc.dilated_pupil_size = settingsToApply.ccc.dilated_pupil_size;
							copy.op_note_os.ccc.pupil_expander = settingsToApply.ccc.pupil_expander;
							copy.op_note_os.ccc.technique_type = settingsToApply.ccc.technique_type;
							copy.op_note_os.ccc.hydrodissection_type = settingsToApply.ccc.hydrodissection_type;
						}
						if (settingsToApply.phaco) {
							if (!copy.op_note_os.phaco) copy.op_note_os.phaco = {};
							copy.op_note_os.phaco.machine = settingsToApply.phaco.machine;
							copy.op_note_os.phaco.technique = settingsToApply.phaco.technique;
							copy.op_note_os.phaco.irrigation = settingsToApply.phaco.irrigation;
						}
						if (settingsToApply.iol) {
							if (!copy.op_note_os.iol) copy.op_note_os.iol = {};
							if (!copy.op_note_os.iol.lens_type) {
								copy.op_note_os.iol.lens_type = settingsToApply.iol.lens_type;
								copy.op_note_os.iol.lens_model = settingsToApply.iol.lens_model;
								copy.op_note_os.iol.lens_power_spherical = settingsToApply.iol.lens_power_spherical;
								copy.op_note_os.iol.lens_power_cylinder = settingsToApply.iol.lens_power_cylinder;
								copy.op_note_os.iol.lens_axis = settingsToApply.iol.lens_axis;
							}
							copy.op_note_os.iol.lens_placement = settingsToApply.iol.lens_placement;
						}
						copy.op_note_os.intraoperative_medications = settingsToApply.intraoperative_medications;
						copy.op_note_os.instructions_for_patient = settingsToApply.instructions_for_patient;

						if (settingsToApply.postop_care) {
							if(!copy.postop_care) {
								copy.postop_care = {};
							}
							copy.postop_care.duration = settingsToApply.postop_care.duration || copy.postop_care.duration;
							copy.postop_care.follow_up_type = copy.postop_care.duration;
							copy.postop_care.other_date = settingsToApply.postop_care.other_date || copy.postop_care.other_date;
							copy.postop_care.follow_up_date = copy.postop_care.other_date;
							copy.postop_care.clinician = settingsToApply.postop_care.clinician || copy.postop_care.clinician;
						}
					}
				}
			}

			$scope.OperationNote = copy;
			rebuildPostOpMedications();
		}

		// The defaults produced by the previous rebuild, so the next one can tell them apart from
		// medications the surgeon typed in by hand.
		let lastDefaultPostOpMedications = [];

		function isSameMedication(a, b) {
			// Route is left out on purpose: the eye watcher re-routes a default when the eye changes,
			// and that re-routed copy is still the default, not something the surgeon added.
			return a.medication === b.medication && a.dose === b.dose && a.frequency === b.frequency && a.duration === b.duration;
		}

		function buildDefaultPostOpMedications() {
			if (!$scope.remoteDefaultSetting || !$scope.remoteDefaultSetting.op_note_settings) {
				return [];
			}

			const combinedMedications = [];
			const opNote = $scope.OperationNote;
			const settings = $scope.remoteDefaultSetting.op_note_settings;

			// --- Process Right Eye (OD) medications ---
			const odProcedureType = opNote.op_note_od?.procedure_type;
			if (opNote.op_note_od?.operative_eye === 'YES' && odProcedureType && settings.op_note_od_settings_list) {
				const odSettings = settings.op_note_od_settings_list.find(s => s.procedure_type === odProcedureType);
				if (odSettings && odSettings.postop_medications) {
					odSettings.postop_medications.forEach(med => {
						const medToAdd = angular.copy(med);
						// Tag the medication as belonging to the right eye, unless it's oral
						if (medToAdd.route !== 'ORAL') {
							medToAdd.route = 'OD';
						}
						combinedMedications.push(medToAdd);
					});
				}
			}

			// --- Process and Merge Left Eye (OS) medications ---
			const osProcedureType = opNote.op_note_os?.procedure_type;
			if (opNote.op_note_os?.operative_eye === 'YES' && osProcedureType && settings.op_note_os_settings_list) {
				const osSettings = settings.op_note_os_settings_list.find(s => s.procedure_type === osProcedureType);
				if (osSettings && osSettings.postop_medications) {
					osSettings.postop_medications.forEach(osMed => {
						// Check if an identical medication already exists for the other eye
						const matchingMed = combinedMedications.find(existingMed => existingMed.route === 'OD' && isSameMedication(existingMed, osMed));

						if (matchingMed) {
							// If a match is found for OD, update its route to 'BOTH'
							matchingMed.route = 'BOTH';
						} else {
							// Otherwise, add it as a new medication for OS
							const medToAdd = angular.copy(osMed);
							if (medToAdd.route !== 'ORAL') {
								medToAdd.route = 'OS';
							}
							combinedMedications.push(medToAdd);
						}
					});
				}
			}

			return combinedMedications;
		}

		// Rebuilds the post-op medication list from the surgeon's defaults for the eyes and procedures
		// now selected, keeping anything the surgeon added by hand since the last rebuild.
		function rebuildPostOpMedications() {
			if (!$scope.OperationNote) {
				return;
			}
			const defaults = buildDefaultPostOpMedications();
			const current = $scope.OperationNote.postop_medications || [];
			const addedByHand = current.filter(med =>
				!lastDefaultPostOpMedications.some(previous => isSameMedication(previous, med)) &&
				!defaults.some(next => isSameMedication(next, med))
			);
			lastDefaultPostOpMedications = angular.copy(defaults);
			$scope.OperationNote.postop_medications = defaults.concat(addedByHand);
		}

		$scope.opNoteOption = {
			addAutoTaskOpNote: false,
			addAutoTaskHistology: false,
			enableAiFollowUp: false
		};

		$scope.onAutomationTaskChange = function(event) {
			if(event.type === 'operation_note_automation_settings'){
				$scope.opNoteOption.addAutoTaskOpNote = event.isAutomationTaskEnabled;
			}else if(event.type === 'histology_automation_settings'){
				$scope.opNoteOption.addAutoTaskHistology = event.isAutomationTaskEnabled;
			}
		}

		// Initialize storage
		$scope.aiCallData = null;

		// This mirrors your onAutomationTaskChange logic
		$scope.onAiCallDataChange = function (data) {
			// This data will contain { agent_id, prompt_id, date_scheduled_utc, etc. }
			$scope.aiCallData = data;
		};

		$scope.toggleAiFollowUp = function () {
			if (!$scope.opNoteOption.enableAiFollowUp) {
				// If user deselects, clear the data so it doesn't trigger on submit
				$scope.aiCallData = null;
			}
		};

		$scope.onAiCallDataChange = function (data) {
			// Only capture data if the checkbox is enabled
			if ($scope.opNoteOption.enableAiFollowUp) {
				$scope.aiCallData = data;
			}
		};

		$scope.onAiCallSaved = function () {
			console.log("AI Call was successfully scheduled from the Op Note");
			if (typeof $scope.fetchScheduledCalls === "function") {
				$scope.fetchScheduledCalls();
			}
		};

		$scope.cancelAiCall = function () {
			console.log("User clicked cancel in the AI section");
		};

		const transformFavoriteProcedureList = (remoteDefaultSetting) => {
			const backupRemoteDefaultSetting = angular.copy(remoteDefaultSetting);
			// null when the settings request failed or the surgeon has no saved settings
			const { favorite_procedure_list } = (backupRemoteDefaultSetting && backupRemoteDefaultSetting.op_note_settings) ?? {};
			$scope.favorite_procedure_list = favorite_procedure_list ?? [];
		};

	},
]);